<template>
  <v-container fluid class="asc-fleet-data-template">
    <v-row no-gutters>
      <v-col cols="12" sm="12">
        <template v-if="!isFleetDataPageActive">
          <asc-page-coming-soon
            label="Fleet Page Coming Soon!"
          ></asc-page-coming-soon>
        </template>
        <template v-if="isFleetDataPageActive">
          <asc-page-header>
            <template #pageTitle>
              <asc-page-title title="FLEET"></asc-page-title>
            </template>
          </asc-page-header>

          <asc-notification
            v-if="getPageAlertDefinitions.length > 0"
            :definition="getPageAlertDefinitions"
          ></asc-notification>

          <asc-tab v-model="selectedTab" secondary @tabChange="handleTabChange">
            <template v-if="fleetPageMyFleetPermission">
              <asc-tab-title
                title="My Fleet"
                icon="mdi-airplane"
                name="myFleet"
              />
            </template>
            <template v-if="fleetPageOpenMaintenancePermission">
              <asc-tab-title
                title="Open Maintenance"
                icon="mdi-alert-circle"
                name="openMaintenance"
              />
            </template>
            <template
              v-if="
                isFleetFaultMsgsTabActive && fleetPageFaultMessagePermission
              "
            >
              <asc-tab-title
                title="Fault Messages"
                icon="mdi-alert"
                name="faultMessages"
              />
            </template>
            <template
              v-if="
                isFleetHealthScoreTabActive && fleetPageHealthScorePermission
              "
            >
              <asc-tab-title
                title="Health Score"
                icon="mdi-alert-box"
                name="healthScore"
              />
            </template>
          </asc-tab>

          <asc-tab-body :value="selectedTab" secondary>
            <template v-if="fleetPageMyFleetPermission">
              <asc-tab-item name="myFleet">
                <!--Deprecated per work item 20777/Jemish-->
                <!--<asc-notification
                  v-if="invalidGlobalFilter"
                  :definition="invalidGlobalFilterDefinition"
                ></asc-notification>-->
                <asc-fleet-my-fleet-wrapper
                  :fleet-data="fleetData"
                  :loading="loading"
                  :is-issue-investigator="isIssueInvestigator"
                  :is-issue-reader="isIssueReader"
                  :is-issue-updater="isIssueUpdater"
                  :on-open-maintenance="onOpenMaintenance"
                  :on-open-fde="onOpenFde"
                  :on-open-connectivity="onOpenConnectivity"
                ></asc-fleet-my-fleet-wrapper>
              </asc-tab-item>
            </template>
            <template v-if="fleetPageOpenMaintenancePermission">
              <asc-tab-item name="openMaintenance">
                <!--Deprecated per work item 20777/Jemish-->
                <!--<asc-notification
                  v-if="invalidGlobalFilter"
                  :definition="invalidGlobalFilterDefinition"
                ></asc-notification>-->
                <asc-fleet-open-maint-wrapper
                  :maintenance-statuses="maintenanceStatuses"
                  :fleet-data="fleetData"
                  :is-issue-investigator="isIssueInvestigator"
                  :is-issue-reader="isIssueReader"
                  :is-issue-updater="isIssueUpdater"
                  :loading="loading"
                  :open-maintenance-data="openMaintenanceData"
                  :open-maintenance-grid-columns="openMaintenanceGridColumns"
                  :on-open-maintenance="onOpenMaintenance"
                  :on-open-fde="onOpenFde"
                  :on-open-connectivity="onOpenConnectivity"
                ></asc-fleet-open-maint-wrapper>
              </asc-tab-item>
            </template>
            <template
              v-if="
                isFleetFaultMsgsTabActive && fleetPageFaultMessagePermission
              "
            >
              <asc-tab-item name="faultMessages">
                <!--Deprecated per work item 20777/Jemish-->
                <!--<asc-notification
                  v-if="invalidGlobalFilter"
                  :definition="invalidGlobalFilterDefinition"
                ></asc-notification>-->
                <asc-fleet-fault-msg-wrapper
                  :loading="loading"
                  :fault-msg-default-filter-options="
                    faultMsgDefaultFilterOptions
                  "
                  :fault-msg-count-by-tail-data="faultMsgCountByTailData"
                  :fault-msg-count-by-ata-chapter-data="
                    faultMsgCountByAtaChapterData
                  "
                  :fault-msg-count-by-para-data="faultMsgCountByParaData"
                  :fault-msg-codes-grid-columns="faultMsgCodesGridColumns"
                  :fault-msg-codes-grid-data="faultMsgCodesGridData"
                  :fault-reports-default-filter-options="
                    faultReportsDefaultFilterOptions
                  "
                  :fault-reports-by-flight-data="faultReportsByFlightData"
                  :on-fault-msg-filters-change="onFaultMsgFiltersChange"
                  :on-fault-msg-tail-change="onFaultMsgTailChange"
                  :on-fault-msg-ata-chapter-change="onFaultMsgAtaChapterChange"
                  :on-fault-msg-para-change="onFaultMsgParaChange"
                  :on-fault-reports-filters-change="onFaultReportsFiltersChange"
                  :on-open-raw-report="onOpenRawReport"
                  :on-view-details="onViewDetails"
                  :on-visualize="onVisualize"
                ></asc-fleet-fault-msg-wrapper>
              </asc-tab-item>
            </template>
            <template
              v-if="
                isFleetHealthScoreTabActive && fleetPageHealthScorePermission
              "
            >
              <asc-tab-item name="healthScore">
                <!--Deprecated per work item 20777/Jemish-->
                <!--<asc-notification
                  v-if="invalidGlobalFilter"
                  :definition="invalidGlobalFilterDefinition"
                ></asc-notification>-->
                <asc-fleet-health-score-wrapper
                  :include-internal-scores="includeInternalScores"
                  :is-feature-investigator="isFeatureInvestigator"
                  :loading="loading"
                  :health-score-default-filter-options="
                    healthScoreDefaultFilterOptions
                  "
                  :health-score-by-tail-data="healthScoreByTailData"
                  :health-score-by-feature-data="healthScoreByFeatureData"
                  :health-score-trend-data="healthScoreTrendData"
                  :health-score-phm-alert-data="healthScorePhmAlertData"
                  :health-score-mx-rec-overlays-data="
                    healthScoreMxRecOverlaysData
                  "
                  :on-health-score-filters-change="onHealthScoreFiltersChange"
                  :on-health-score-tail-change="onHealthScoreTailChange"
                  :on-health-score-feature-change="onHealthScoreFeatureChange"
                  :on-toggle-include-internal-scores="
                    onToggleIncludeInternalScores
                  "
                ></asc-fleet-health-score-wrapper>
              </asc-tab-item>
            </template>
          </asc-tab-body>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AscPageHeader from '../atoms/AscPageHeader.vue'
import AscPageTitle from '../atoms/AscPageTitle.vue'
import AscTab from '../atoms/AscTab.vue'
import AscTabBody from '../atoms/AscTabBody.vue'
import AscTabItem from '../atoms/AscTabItem.vue'
import AscTabTitle from '../atoms/AscTabTitle.vue'

import AscNotification from '../molecules/AscNotification.vue'
import AscPageComingSoon from '../molecules/AscPageComingSoon.vue'

import AscFleetFaultMsgWrapper from '../organisms/AscFleetFaultMsgWrapper.vue'
import AscFleetHealthScoreWrapper from '../organisms/AscFleetHealthScoreWrapper.vue'
import AscFleetMyFleetWrapper from '../organisms/AscFleetMyFleetWrapper.vue'
import AscFleetOpenMaintWrapper from '../organisms/AscFleetOpenMaintWrapper.vue'

import AscGridPropsMixin from '../mixins/AscGridPropsMixin.vue'
import AscRangeDatePickerMixin from '../mixins/AscRangeDatePickerMixin.vue'

import AppFeatureFlags from '@/utilities/appFeatureFlags'

export default {
  name: 'AscFleetDataTemplate',

  components: {
    AscPageHeader,
    AscPageTitle,
    AscNotification,
    AscPageComingSoon,
    AscTab,
    AscTabTitle,
    AscTabBody,
    AscTabItem,
    AscFleetMyFleetWrapper,
    AscFleetOpenMaintWrapper,
    AscFleetFaultMsgWrapper,
    AscFleetHealthScoreWrapper,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],

  props: {
    currentTab: {
      type: String,
      default: null,
    },
    invalidGlobalFilter: {
      type: Boolean,
      default: false,
    },
    pageAlertDefinitions: {
      type: Array,
      default: () => [],
    },
    fleetData: {
      type: Array,
      default: () => [],
    },
    healthScoreDefaultFilterOptions: {
      type: Array,
      default: () => [],
    },
    healthScoreByTailData: {
      type: Array,
      default: () => [],
    },
    healthScoreByFeatureData: {
      type: Array,
      default: () => [],
    },
    healthScoreTrendData: {
      type: Object,
      default: () => {},
    },
    healthScorePhmAlertData: {
      type: Array,
      default: () => [],
    },
    healthScoreMxRecOverlaysData: {
      type: Array,
      default: () => [],
    },
    openMaintenanceData: {
      type: Array,
      default: () => [],
    },
    openMaintenanceGridColumns: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    includeInternalScores: {
      type: Boolean,
      default: false,
    },
    isFeatureInvestigator: {
      type: Boolean,
      default: false,
    },
    isIssueInvestigator: {
      type: Boolean,
      default: false,
    },
    isIssueReader: {
      type: Boolean,
      default: false,
    },
    isIssueUpdater: {
      type: Boolean,
      default: false,
    },
    internalUser: {
      type: Boolean,
      default: false,
    },
    onOpenMaintenance: {
      type: Function,
      default: () => {},
    },
    onOpenFde: {
      type: Function,
      default: () => {},
    },
    onOpenConnectivity: {
      type: Function,
      default: () => {},
    },
    onTabChange: {
      type: Function,
      default: () => {},
    },
    loadingPlot: {
      type: Boolean,
      default: false,
    },
    faultMsgDefaultFilterOptions: {
      type: Array,
      default: () => [],
    },
    faultMsgCountByTailData: {
      type: Array,
      default: () => [],
    },
    faultMsgCountByAtaChapterData: {
      type: Array,
      default: () => [],
    },
    faultMsgCountByParaData: {
      type: Array,
      default: () => [],
    },
    faultMsgCodesGridColumns: {
      type: Array,
      default: () => [],
    },
    faultMsgCodesGridData: {
      type: Array,
      default: () => [],
    },
    faultReportsDefaultFilterOptions: {
      type: Array,
      default: () => [],
    },
    faultReportsByFlightData: {
      type: Array,
      default: () => [],
    },
    onFaultMsgFiltersChange: {
      type: Function,
      default: () => {},
    },
    onFaultMsgTailChange: {
      type: Function,
      default: () => {},
    },
    onFaultMsgAtaChapterChange: {
      type: Function,
      default: () => {},
    },
    onFaultMsgParaChange: {
      type: Function,
      default: () => {},
    },
    onFaultReportsFiltersChange: {
      type: Function,
      default: () => {},
    },
    onOpenRawReport: {
      type: Function,
      default: () => {},
    },
    onViewDetails: {
      type: Function,
      default: () => {},
    },
    onVisualize: {
      type: Function,
      default: () => {},
    },
    onHealthScoreFiltersChange: {
      type: Function,
      default: () => {},
    },
    onHealthScoreTailChange: {
      type: Function,
      default: () => {},
    },
    onHealthScoreFeatureChange: {
      type: Function,
      default: () => {},
    },
    onToggleIncludeInternalScores: {
      type: Function,
      default: () => {},
    },
    fleetPageOpenMaintenancePermission: {
      type: Boolean,
      default: false,
    },
    fleetPageMyFleetPermission: {
      type: Boolean,
      default: false,
    },
    fleetPageFaultMessagePermission: {
      type: Boolean,
      default: false,
    },
    fleetPageHealthScorePermission: {
      type: Boolean,
      default: false,
    },
    maintenanceStatuses: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedTab: this.currentTab,
      //Deprecated per work item 20777/Jemish
      /*invalidGlobalFilterDefinition: [
        {
          color: 'alert',
          isActive: true,
          text: 'One or more airlines selected in Global Filter does not have a valid Collins PHM Agreement.',
          type: 'alert',
          dismissible: false,
        },
      ],*/
    }
  },

  computed: {
    isFleetDataPageActive() {
      return AppFeatureFlags.getFleetDataPage()
    },
    isFleetFaultMsgsTabActive() {
      return AppFeatureFlags.getFleetFaultMsgsTab()
    },
    isFleetHealthScoreTabActive() {
      return AppFeatureFlags.getFleetHealthScoreTab()
    },
    getPageAlertDefinitions() {
      return this.pageAlertDefinitions
    },
  },

  watch: {
    currentTab(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedTab = newVal
      }
    },
  },

  methods: {
    handleTabChange(whichTab) {
      if (this.onTabChange) {
        this.onTabChange(whichTab)
      }
    },
    handleHealthScoreDataChanged(data) {
      this.$emit('healthScoreDataUpdated', data)
    },
  },
}
</script>

<style lang="scss">
.asc-fleet-data-template {
  background-color: $gray-100;

  .asc-tab__content--secondary {
    background-color: $gray-100 !important;
    padding: 0;
  }

  .asc-notification-wrapper {
    margin-bottom: 16px;
  }

  .asc-tabs .v-tabs-bar__content {
    background-color: $primary-white !important;
  }
}
</style>
